import { clearAccessToken } from '@podus/auth';
import { authUrl } from './config';

/** 401 messages from NEW_PODUS_API's userMiddleware that mean the user must sign in again */
const SESSION_MESSAGES = [
    'You are not logged in',
    'Session Expired, Please login again',
    "Something went wrong, can't find your account",
];

export function isSessionMessage(message: string): boolean {
    return SESSION_MESSAGES.includes(message);
}

let redirecting = false;

/**
 * Sends the user to auth.podus.org to sign in, then back to the page they were on.
 * Runs once even if several requests fail together.
 */
export function redirectToSignIn(): void {
    if (redirecting) return;
    redirecting = true;
    clearAccessToken();
    window.location.assign(`${authUrl()}/sign-in?redirect=${encodeURIComponent(window.location.href)}`);
}

/**
 * Where to go after signing out: auth's sign-out page clears its own cookie too, so the next
 * sign-in asks for a code instead of silently reusing the old session.
 */
export function signOutUrl(): string {
    return `${authUrl()}/sign-out?redirect=${encodeURIComponent(`${window.location.origin}/`)}`;
}
